<script>
import InputField from "@/components/input/InputField.vue"
import RadioField from "@/components/input/RadioField.vue";
import {api} from "@/modules/api";
import {toast} from "vue3-toastify";

export default {
  name: 'FormProfil',
  components: {RadioField, InputField},
  props: {
    profil: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      dataForm: {}
    }
  },
  mounted () {
    this.dataForm.lastname = this.profil.lastname
    this.dataForm.firstname = this.profil.firstname
    this.dataForm.email = this.profil.email
    this.dataForm.phone = this.profil.phone
    const address = this.profil.Address.filter(address => {
      return address.isMain
    })
    this.dataForm.selectedAddress = address[0] ? address[0].id : null
  },
  methods: {
    submit () {
      api.profil.update(this.dataForm).then(() => {
        this.$emit('closeView')
        this.emitter.emit('load-data', true)
        toast('Vos informations ont bien été enregistré !')
      })
    }
  }
}
</script>

<template>
  <div>
    <div class="space-y-4">
      <input-field
          v-model="dataForm.lastname"
          label="Nom"
          placeholder="Nom.."
      />
      <input-field
          v-model="dataForm.firstname"
          type="text"
          label="Prénom"
          placeholder="Prénom.."
      />
      <input-field
          v-model="dataForm.email"
          label="Email"
          type="email"
          placeholder="example@mail.fr"
      />
      <input-field
          v-model="dataForm.phone"
          label="Téléphone"
          type="email"
          placeholder="0606060606"
      />
      <h2>
        Mes adresses
      </h2>
      <radio-field v-if="dataForm.selectedAddress" v-model="dataForm.selectedAddress" :options="profil.Address"/>
      <div class="bottom-0 left-0 flex justify-center w-full pb-4 space-x-4 md:px-4 md:absolute">
        <button @click="submit" class="text-white w-full justify-center bg-primary-700 hover:bg-primary-800 focus:ring-4 focus:outline-none focus:ring-primary-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center">
          Valider
        </button>
        <button @click="$emit('closeView')" class="inline-flex w-full justify-center text-gray-500 items-center bg-white hover:bg-gray-100 focus:ring-4 focus:outline-none focus:ring-primary-300 rounded-lg border border-gray-200 text-sm font-medium px-5 py-2.5 hover:text-gray-900 focus:z-10">
          <svg aria-hidden="true" class="w-5 h-5 -ml-1 sm:mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path></svg>
          Cancel
        </button>
      </div>
    </div>
  </div>
</template>
